import type { SiteName } from '@/scopes/common/domain/types'

const CONTACT_DOMAIN_CODES: Partial<Record<SiteName, string>> = {
  elizabe: 'EZBE',
  elizanl: 'EZNL',
  sunwebbefr: 'SWBEFR',
  sunwebbenl: 'SWBENL',
  sunwebde: 'SWDE',
  sunwebdk: 'SWDK',
  sunwebfr: 'SWFR',
  sunwebnl: 'SWNL',
  sunwebse: 'SWSE',
  sunwebuk: 'SWUK',
}

export function getContactDomainCode(siteName: SiteName): string | undefined {
  return CONTACT_DOMAIN_CODES[siteName]
}
